import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';
import { PfDue } from './pfDueTypes';

// Create PF Due
export const createPfDue = createAsyncThunk(
  'pfDue/create',
  async (data: PfDue, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/pf-due', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create PF Due');
    }
  }
);

// Fetch All PF Dues
export const fetchAllPfDues = createAsyncThunk(
  'pfDue/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/pf-due');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF Dues');
    }
  }
);

// Update isProcessed
export const updatePfDueIsProcessed = createAsyncThunk(
  'pfDue/updateIsProcessed',
  async (
    {
      id,
      isProcessed,
      modifiedBy
    }: { id: number; isProcessed: number; modifiedBy: number },
    { rejectWithValue }
  ) => {
    try {
      const res = await payrollServiceApiInstance.put(`/pf-due/${id}/is-processed`, {
        isProcessed,
        modifiedBy
      });
      return { id, isProcessed };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update PF Due status');
    }
  }
);
